import { getSurvey, getMonkeys } from '../api'

export const useSurveyManagement = () => {
    return {
        fetchSurvey: getSurvey,
        fetchMonkeys: getMonkeys,
    }
}
